export default __webpack_public_path__ + "static/media/gal01.65b54003.svg";